import Flex from "@/components/flex"
import { Link } from "react-router-dom"
import { formatMessage } from "@/utils/format-message"

const AnomalyCard = ({ item, countText }) => {
  const Icon = item.icon

  return (
    <Link
      to={item.path}
      className="
        border border-gray-100 rounded-2xl
        p-4 flex items-center justify-between
        hover:bg-gray-50/50 transition-colors cursor-pointer
      "
    >
      <Flex>
        <div
          className={`
            w-11 h-11 rounded-xl
            flex items-center justify-center
            ${item.bg}
          `}
        >
          <Icon className={`w-5 h-5 ${item.color}`} />
        </div>

        <div className="text-left">
          <p className="font-bold text-gray-800 text-sm">{item.title}</p>

          <p className="text-xs text-gray-400 mt-0.5 pr-2">{item.desc}</p>

          {item.type === "anomaly" && item.breakdown?.length > 0 && (
            <div className="text-xs text-gray-500 mt-1">
              {item.breakdown.map((item) => (
                <span key={item.key} className="mr-2">
                  {item.label} {formatMessage(countText, { count: item.count })}
                </span>
              ))}
            </div>
          )}
        </div>
      </Flex>

      <span className={`font-bold text-sm shrink-0 ${item.color}`}>{item.value}</span>
    </Link>
  )
}

export default AnomalyCard
